import PropTypes from 'prop-types';
import React from 'react';
import { Iterable } from 'immutable';

import MainPage from '../components/MainPage.react';
import SyncTable from '../components/SyncTable.react';
import SyncFilter from '../components/filters/SyncFilter.react';

import CurrentOrganizationIdStore from '../stores/CurrentOrganizationIdStore';
import SyncActions from '../actions/SyncActions';

import SyncStore from '../stores/SyncStore';
import withFilter from '../components/hocs/withFilter.react';

import { SyncFilters, makeSyncFilter } from '../util/Filters';

function sortSyncs(syncs) {
  return syncs.sort((a, b) => b.timestamp.toDate() - a.timestamp.toDate());
}

class Syncs extends React.Component {
  componentDidMount() {
    this.stopPolling = SyncActions.pollSyncs(CurrentOrganizationIdStore.getState());
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  render() {
    return (
      <MainPage>
        <SyncFilter
          filters={this.props.filters}
          updateFilter={this.props.updateFilter}
        />
        <SyncTable
          syncs={sortSyncs(this.props.filteredObjects)}
        />
        {this.props.children}
      </MainPage>
    );
  }
}

export default withFilter(SyncStore, new SyncFilters(), makeSyncFilter)(Syncs);

Syncs.propTypes = {
  filters: PropTypes.instanceOf(SyncFilters),
  updateFilter: PropTypes.func,
  filteredObjects: PropTypes.instanceOf(Iterable),
};
